import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_ELIMINAR_AVIS_EN_CURS,
        AVIS_VISUALITZACIO_ELIMINAR_AVIS_FINALITZADA } from '../../../../actions/actionTypes';

const ESTAT_INICIAL_PETICIO_ELIMINAR_EN_CURS = false;

const peticioEliminarEnCurs = (state = ESTAT_INICIAL_PETICIO_ELIMINAR_EN_CURS, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL_PETICIO_ELIMINAR_EN_CURS;

        case AVIS_VISUALITZACIO_ELIMINAR_AVIS_EN_CURS:
            return true;

        case AVIS_VISUALITZACIO_ELIMINAR_AVIS_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioEliminarEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/avisos/peticioEliminarEnCurs.js